import { Workbook } from 'exceljs';
import moment from 'moment';

import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';

export const onExporting = (e: any) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('1');

  e.component.columnOption('requestStatus', 'visible', false);
  e.component.columnOption('shipped', 'visible', false);
  e.component.columnOption('customColumn', 'visible', false);
  e.component.columnOption('requestTotal', 'visible', false);

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
    customizeCell: ({ gridCell, excelCell }) => {
      if (gridCell!.rowType === 'data') {
        if (gridCell!.column!.dataField === 'date') {
          excelCell.value = moment(gridCell!.value).format('DD.MM.YYYY HH:mm');
        }
      }
    },
  })
    .then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'заявки.xlsx');
      });
    })
    .finally(() => {
      e.component.columnOption('requestStatus', 'visible', true);
      e.component.columnOption('shipped', 'visible', true);
      e.component.columnOption('customColumn', 'visible', true);
      e.component.columnOption('requestTotal', 'visible', true);
    });

  e.cancel = true;
};
